// src/pages/About.jsx
import React from "react";
import MainLayout from "../components/Layouts/MainLayout";
import InnerBanner from "../components/PagesComponents/InnerBanner";
import { useLanguage } from "../contexts/LanguageContext"; // Import Language Context
import { translations } from "../i18n"; // Import Translations
import importImage from "../utils/images/importImage";

const Checkout = () => {
  const secImage3 = importImage("section-image3.jpg");
  const secImage4 = importImage("section-image4.jpg");
  const { language } = useLanguage(); // Get the current language
  const aboutData = translations[language]?.aboutData; // Fetch translations for "about"


  return (
    <MainLayout>
      <InnerBanner pageKey="checkout" />
      <section className="py-5">
  <div className="container">
    <div className="row">
      <div className="col-lg-6">
        <div className="sm-cn-wrap order-summary">
          <h4 className="mb-4">Your Cart (2 items)</h4>
          <div className="cart-item-list">
            <div className="row mb-3 align-items-center cart-item">
              <div className="col-md-5 d-flex">
                <img src="https://placehold.co/50x40" className="mr-3" alt="Product Image" />
                <div>
                  <h2 className="h6 mb-0">Lorem ipsuim dummy</h2>
                </div>
              </div>
              <div className="col-md-2">
                <p className="mb-0">$469.99</p>
              </div>
              <div className="col-md-3 qty-control">
                <button className="btn btn-outline-secondary btn-sm" aria-label="Decrease quantity">-</button>
                <input type="text" defaultValue="1" className="form-control form-control-sm" aria-label="Quantity" />
                <button className="btn btn-outline-secondary btn-sm" aria-label="Increase quantity">+</button>
              </div>
              <div className="col-md-2 text-end">
                <button className="btn btn-danger btn-sm" aria-label="Remove item">X</button>
              </div>
            </div>

            <div className="row mb-3 align-items-center cart-item">
              <div className="col-md-5 d-flex">
                <img src="https://placehold.co/50x40" className="mr-3" alt="Product Image" />
                <div>
                  <h2 className="h6 mb-0">Lorem ipsuim dummy</h2>
                </div>
              </div>
              <div className="col-md-2">
                <p className="mb-0">$549.99</p>
              </div>
              <div className="col-md-3 qty-control">
                <button className="btn btn-outline-secondary btn-sm" aria-label="Decrease quantity">-</button>
                <input type="text" defaultValue="1" className="form-control form-control-sm" aria-label="Quantity" />
                <button className="btn btn-outline-secondary btn-sm" aria-label="Increase quantity">+</button>
              </div>
              <div className="col-md-2 text-end">
                <button className="btn btn-danger btn-sm" aria-label="Remove item">X</button>
              </div>
            </div>
          </div>

          <div className="cart-summary text-end mt-4">
            <p>Subtotal: <span>$1,019.98</span></p>
            <p>Sales Tax: <span>$102.00</span></p>
            <p>Coupon Code: <a href="#">Add Coupon</a></p>
            <h3 className="mt-3">Grand Total: $1,121.98</h3>
            <p className="text-success">Congrats, you're eligible for <span>Free Shipping</span></p>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div className="big-cn-wrap">
          <form>
            <div className="row">
              <div className="col-lg-12 mb-3">
                <label htmlFor="fullName" className="form-label">Full Name *</label>
                <input type="text" className="form-control" id="fullName" name="fullName" required />
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="phone" className="form-label">Phone *</label>
                <input type="tel" className="form-control" id="phone" name="phone" required />
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="email" className="form-label">Email Address *</label>
                <input type="email" className="form-control" id="email" name="email" required />
              </div>

              <div className="col-lg-12 mb-3">
                <label htmlFor="companyName" className="form-label">Company Name (Optional)</label>
                <input type="text" className="form-control" id="companyName" name="companyName" />
              </div>

              <div className="col-lg-12 mb-3">
                <label htmlFor="country" className="form-label">Country / Region *</label>
                <select className="form-select form-control" id="country" name="country" required>
                  <option value="">Select a country</option>
                  <option value="US">United States</option>
                  <option value="UK">United Kingdom</option>
                  <option value="IN">India</option>
                </select>
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="streetAddress" className="form-label">Street Address *</label>
                <input type="text" className="form-control" id="streetAddress" name="streetAddress" required />
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="townCity" className="form-label">Town / City *</label>
                <input type="text" className="form-control" id="townCity" name="townCity" required />
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="state" className="form-label">State *</label>
                <select className="form-select form-control" id="state" name="state" required>
                  <option value="">Select a state</option>
                  <option value="NY">New York</option>
                  <option value="CA">California</option>
                </select>
              </div>

              <div className="col-lg-6 mb-3">
                <label htmlFor="zipCode" className="form-label">ZIP Code *</label>
                <input type="text" className="form-control" id="zipCode" name="zipCode" required />
              </div>

              <div className="col-lg-12 mb-3">
                <label htmlFor="orderNotes" className="form-label">Order Notes (Optional)</label>
                <textarea className="form-control" id="orderNotes" name="orderNotes" rows="3"></textarea>
              </div>

              <div className="col-lg-12">
                <button type="submit" className="btn-dashboard">Check Out</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
      
</MainLayout>
  );
};

export default Checkout;